import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

const LoadMoreContainer = styled.div`
  padding: 32px 0 32px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: fit-content;

  ${breakpoints.md} {
    padding: 32px 64px;
  }

  ${breakpoints.lg} {
    padding: 64px 0 101px;
  }
`;

export default LoadMoreContainer;
